<template>
    <div>
        <div class="mb-6">
            <div v-if="$route.params.id === 'profiles'" class="title py-3 px-4 title-div">
                <p class="caption mb-0">
                    <a href="#/" class="grey--text text--lighten-2">Home / </a>
                    <a class="grey--text text--lighten-2">{{$route.params.category}} / </a>
                    <a :href="`#/${$route.params.category}/${$route.params.contentType}`" class="grey--text text--lighten-2">{{$route.params.contentType}}</a>
                </p>
                Division Heads
            </div>
            <div v-else class="title py-3 px-4 title-div">
                <p class="caption mb-0">
                    <a href="#/" class="grey--text text--lighten-2">Home / </a><a class="grey--text text--lighten-2">{{$route.params.category}} / </a><a :href="`#/${$route.params.category}/${$route.params.contentType}`" class="grey--text text--lighten-2">{{$route.params.contentType}}</a>
                </p>
                {{newsTitle}}
            </div>
            <v-progress-linear
            v-if="loadingPage"
            indeterminate
            color="primary"
            ></v-progress-linear>
        </div>
        <v-row row wrap class="mt-3 px-4">
            <v-col md="3" class="pl-0  hidden-sm-and-down">
                <div class="">
                <div
                v-for="(value, key) in navItems"
                :key="key"
                >
                    <v-list-group
                    dense
                    class="elevation-0"
                    :value="$route.params.category === key ? true : false"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title class="px-0">{{key}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                        v-for="n in value"
                        :key="n"
                        @click="() => {}"
                        link
                        :href="n === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${key}/${n}`"
                        >
                            <v-list-item-title class="px-0 font-weight-light" :class="$route.params.contentType === n ? 'info--text' : ''">{{n === "Why Join AGO" ? n + '?' : n}}</v-list-item-title>
                            <v-divider></v-divider>
                        </v-list-item>
                    </v-list-group>
                    <v-divider></v-divider>
                </div>
                </div>
            </v-col>
            <v-col cols="11" sm="11" md="8" >
                <div v-if="!loadingPage">
                    <div v-if="$route.params.id === 'profiles'">
                        <p class="display-1 mb-5 primary--text">Division Heads</p>
                        <div v-for="(n, index) in divisionHeads" :key="index + 'profile'">
                            <v-row>
                                <v-col cols="4" md="2">
                                    <v-img
                                    max-height="200" 
                                    contain
                                    :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                                    :lazy-src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                                    class="transparent lighten-2"
                                    >
                                        <template v-slot:placeholder>
                                            <v-layout
                                                fill-height
                                                align-center
                                                justify-center
                                                ma-0
                                                >
                                                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                            </v-layout>
                                        </template>
                                    </v-img>
                                </v-col>
                            </v-row>
                            <p class="mt-3 text-xs-center"><a :href="`#/About%20Us/Organization%20Structure/profile/${n.Title.split('#')[0].length > 1 ?n.Title.split('#')[0] : n.Title.split('#')[1]}`" class="title">{{n.Title.split('#').length > 0 ? n.Title.split('#')[1] : ''}}</a><br>
                            <span class="subheading text-xs-center">{{n.Title.split('#')[0]}}</span><br> </p>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="contents[0]">
                            <p class="display-1 mb-5 primary--text" v-html="contents[0].Title"></p>
                            <p class="caption">{{contents[0].Date | moment("DD-MM-YYYY")}}</p>
                            <v-carousel
                            v-if="getImage(contents[0]).length > 1"
                            cycle
                            show-arrows-on-hover
                            hide-delimiters
                            height="400px"
                            class="mb-5"
                            >
                                <v-carousel-item
                                v-for="(slide, i) in getImage(contents[0])"
                                :key="i"
                                >
                                    <v-img
                                    :src="getImageUrl(slide.ID)"
                                    class="transparent mb-4"
                                    style="height: 400px"
                                    aspect-ratio="1"
                                    position="bottom center"
                                    >
                                        <template v-slot:placeholder>
                                            <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                            >
                                            <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                </v-carousel-item>
                            </v-carousel>
                            <!-- {{getImage(contents[0])}}ss -->
                            <v-img
                            v-else-if="getImage(contents[0]).length <= 1 && getImage(contents[0]).length > 0"
                            :src="getImageUrl(getImage(contents[0])[0].ID)"
                            class="transparent mb-4"
                            contain
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>

                        
                            <!-- <v-img
                            :src="getImage(contents[0])"
                            class="transparent mb-4"
                            contain
                            v-if="getImage(contents[0]) != '' && !agProfile"
                            >
                                <template v-slot:placeholder>
                                    <v-layout
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-layout>
                                </template>
                            </v-img> -->
                            <div class="ql-editor px-0" v-html="contents[0] ? contents[0].Body : ''"></div>
                            <div v-if="contents[0].Files.length > 0">
                                <!-- <p class="subheading mt-4">Documents</p> -->
                                <p v-for="a in getWithoutImages(contents[0].Files)" :key="a.ID + 'FileDownload'">
                                    <a :href="`${$url}/downloadfile/${a.ID}`" v-html="a.FileTitle"></a>
                                </p>
                            </div>
                        </div>
                        <div v-else>
                            <p class="title">Page Not Found!</p>
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col cols="1">
                <div class="sticky">
                    <v-btn icon class="my-2" @click="printPage()" color="grey lighten-1">
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`http://www.facebook.com/sharer.php?u=${currentUrl}`" target="_blank" icon class="my-2" color="grey lighten-1">
                        <v-icon>mdi-facebook</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`https://twitter.com/intent/tweet?url=${currentUrl}`" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-twitter</v-icon>
                    </v-btn>
                    <br>
                    <v-btn href="mailTo:info@agoffice.gov.mv" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-email</v-icon>
                    </v-btn>
                </div>
            </v-col>

        </v-row>
        
    </div>
</template>
<script>
    export default {
        props: ['navItems'],
        data: ()=>({
            divisionHeads: [],
            contents: [],
            currentUrl: window.location.href,
            loadingPage: true,
            newsTitle: ''
        }),
        created () {
            // console.log(this.$route.params.id)
            if (this.$route.params.id === 'profiles') {
                this.$http.get(`${this.$url}/pagination/2/Division%20Heads?limit=20&page=0&sort=id%20desc`).then((response) => {
                    this.divisionHeads = response.data.data.rows
                    this.loadingPage = false
                    // console.log(this.divisionHeads)
                })
            }
            else {
                this.$http.get(`${this.$url}/pagination/2/${this.$route.params.category}?limit=1&page=0&id.contains=${this.$route.params.id}&sort=id%20desc`).then((response)=>{
                    this.contents = response.data.data.rows
                    this.newsTitle = this.contents.length > 0 ? this.contents[0].Title : ''
                    this.loadingPage = false
                // if (this.news.length > 0) {
                //   this.items.push({text: this.news[0].Category == 'Pressrelease' ? 'ނޫސްބަޔާން' : this.news[0].Category == 'News' ? 'ޙަބަރު' : 'އިއުލާން', disabled: false, href: ''}, {text: this.news[0].Title.substring(0, 50) + '....', disabled: true, href: ''})
                // }
                })
            }
        },
        methods: {
            getWithoutImages (files) {
                return files.filter(item => !item.FileType.includes('image'))
            },
            getImage(item) {
                console.log(item.Files && item.Files.length > 0)
                if (item.Files && item.Files.length > 0) {
                    let images = item.Files.filter(obj => obj.FileType.includes('image'))
                    console.log(images)
                    if (images.length > 0) {
                        // return `${this.$url}/downloadfile/${images[0].ID}`
                        return images
                    }
                    else {
                    return []
                    }
                }
                else {
                    return []
                }
            },
            getImageUrl (id) {
                return `${this.$url}/downloadfile/${id}`
            }
        }
    }
</script>